//
import axios from 'axios'

//


const NC_ROUTE = process.env.VUE_APP_API_ROUTE +"/sl_sale_credit_note/generate/by_line"
const SEARCH_TICKET = process.env.VUE_APP_API_ROUTE + "/dte/number/"

/**
 *
 */
const generateCreditNoteByLine = async (data) => {
    try {
        let response = await axios.post(NC_ROUTE, data)
        return response.data
    } catch (error) {
        return error.response.data
    }
}

const getDTE = async function(number, type) {
  let ticket = type == 2 ? 0 : 1

  try {
      let response = await axios.get(
          //'http://dgz1.cl/public/api/pos_daily_cash',
          SEARCH_TICKET + number,
          {
              params: {
                  is_ticket: ticket,
              },
          }
      )
      return response
  } catch (error) {
      console.log('ERROR')
      console.log(error.response)
      return error.response.data
  }
}

//
export default {
    generateCreditNoteByLine,
    getDTE,
}
